/* unplugin-vue-components disabled */import __unplugin_components_0 from 'D:/hjj/bio_link_pc/src/components/common/inputSend.vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "common"
};
var _hoisted_2 = {
  class: "common_info"
};
var _hoisted_3 = {
  class: "title_user"
};
var _hoisted_4 = {
  class: "text_part"
};
var _hoisted_5 = ["innerHTML"];
var _hoisted_6 = {
  class: "time"
};
import { set_business_comment } from '@/api/apis';
import { useUserStore } from '@/store/user';
import { ElMessage } from 'element-plus';
export default {
  __name: 'commonItem',
  props: {
    common: {
      type: Object,
      default: {}
    },
    comment_type: {
      type: Number,
      default: 0
    },
    id: {
      type: Number,
      default: 0
    }
  },
  emits: ['onSuccess'],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var userStore = useUserStore();
    var emit = __emit;
    var props = __props;
    var is_show_send = ref(false);
    var handleSend = val => {
      // businesses_id: "190"
      // comment_id: 262
      // comment_type: 2
      // content: "<p>回复邓丽娇:你好有位</p>"
      var obj = {
        comment_id: props.common.id,
        businesses_id: props.id,
        comment_type: props.comment_type,
        content: val
      };
      if (!obj.content) {
        ElMessage({
          type: 'warning',
          message: '请填写评论内容'
        });
        return;
      }
      set_business_comment(obj, 'post').then(res => {
        if (res.code == 200) {
          is_show_send.value = false;
          emit('onSuccess');
        }
      });
    };
    return (_ctx, _cache) => {
      var _props$common$busine, _props$common$busine2;
      var _component_input_send = __unplugin_components_0;
      return _openBlock(), _createElementBlock(_Fragment, null, [__props.common ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "imgbox",
        style: _normalizeStyle({
          'background-color': _unref(userStore).user_list_color[__props.common.businesses_comment_user[0].id]
        })
      }, [_createElementVNode("span", null, _toDisplayString((_props$common$busine = __props.common.businesses_comment_user[0]) === null || _props$common$busine === void 0 ? void 0 : _props$common$busine.name.substr(-1)), 1)], 4), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createTextVNode(_toDisplayString(__props.common && __props.common.businesses_comment_user && ((_props$common$busine2 = __props.common.businesses_comment_user[0]) === null || _props$common$busine2 === void 0 ? void 0 : _props$common$busine2.name)) + " ", 1), __props.common.comment_user ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_cache[1] || (_cache[1] = _createElementVNode("span", {
        class: "iconfont icon-kaishi"
      }, null, -1)), _createTextVNode(" " + _toDisplayString(__props.common.comment_user), 1)], 64)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("span", {
        innerHTML: __props.common.content
      }, null, 8, _hoisted_5)]), _createElementVNode("div", _hoisted_6, [_createTextVNode(_toDisplayString(__props.common.updated_at) + " ", 1), _createElementVNode("span", {
        class: "reply",
        onClick: _cache[0] || (_cache[0] = $event => is_show_send.value = !_unref(is_show_send))
      }, _toDisplayString(_unref(is_show_send) ? "收起" : "回复"), 1)])])])) : _createCommentVNode("", true), _withDirectives(_createVNode(_component_input_send, {
        style: {
          "flex": "1"
        },
        onOnSend: handleSend
      }, null, 512), [[_vShow, _unref(is_show_send)]])], 64);
    };
  }
};